/* eslint-disable no-nested-ternary */

import type { Labels, Provider } from './types'

export function getLabels(provider: Provider): Labels {
    const providerName =
        provider === 'aws'
            ? 'AWS'
            : provider === 'gcp'
            ? 'Google Cloud'
            : provider === 'azure'
            ? 'Microsoft Azure'
            : provider === 'odp'
            ? 'OmanDataPark'
            : 'On Premise'

    const isOnPrem = provider === 'onprem' || provider === 'odp'

    return {
        providerName,
        vmName:
            provider === 'aws'
                ? 'EC2 instances'
                : provider === 'gcp'
                ? 'Compute Engine VMs'
                : provider === 'azure'
                ? 'Azure VMs'
                : 'VMs/hosts',
        computeOptimizer:
            provider === 'aws'
                ? 'AWS Compute Optimizer'
                : provider === 'gcp'
                ? 'GCP Recommender'
                : provider === 'azure'
                ? 'Azure Advisor'
                : 'capacity planning tools',
        savingsLabel:
            provider === 'aws'
                ? 'Savings Plans / Reserved Instances'
                : provider === 'gcp'
                ? 'Committed Use Discounts (CUDs)'
                : provider === 'azure'
                ? 'Reservations / Savings Plan'
                : 'reserved capacity/licensing',
        dbName:
            provider === 'aws'
                ? 'RDS'
                : provider === 'gcp'
                ? 'Cloud SQL'
                : provider === 'azure'
                ? 'Azure SQL / Managed DB'
                : 'databases',
        objectStorage:
            provider === 'aws'
                ? 'S3'
                : provider === 'gcp'
                ? 'Cloud Storage'
                : provider === 'azure'
                ? 'Azure Blob Storage'
                : 'object storage',
        objectStorageClasses:
            provider === 'aws'
                ? 'Standard-IA / Glacier tiers'
                : provider === 'gcp'
                ? 'Nearline / Coldline / Archive'
                : provider === 'azure'
                ? 'Cool / Archive'
                : 'lower-cost / cold / archive tiers',
        blockStorage:
            provider === 'aws'
                ? 'EBS volumes'
                : provider === 'gcp'
                ? 'Persistent Disks'
                : provider === 'azure'
                ? 'Managed Disks'
                : 'block storage volumes',
        blockStorageUpgrade:
            provider === 'aws'
                ? 'migrate gp2 to gp3 and decouple IOPS/throughput'
                : provider === 'gcp'
                ? 'use PD-balanced or right-size pd-ssd for price/perf'
                : provider === 'azure'
                ? 'consider Premium v2 or right-size disk SKUs'
                : 'move to cost-optimized tiers and right-size performance',
        snapshotWord: provider === 'aws' ? 'EBS snapshots' : 'snapshots',
        cdnName:
            provider === 'aws'
                ? 'CloudFront'
                : provider === 'gcp'
                ? 'Cloud CDN'
                : provider === 'azure'
                ? 'Azure CDN'
                : 'CDN (or third-party)',
        privateNet:
            provider === 'aws'
                ? 'PrivateLink / VPC endpoints'
                : provider === 'gcp'
                ? 'Private Service Connect'
                : provider === 'azure'
                ? 'Private Link / Service Endpoints'
                : 'private networking',
        eipLabel:
            provider === 'aws'
                ? 'Elastic IPs'
                : provider === 'gcp'
                ? 'static external IPs'
                : provider === 'azure'
                ? 'public IPs'
                : 'public IPs',
        lbLabel:
            provider === 'aws'
                ? 'load balancers (ALB/NLB)'
                : provider === 'gcp'
                ? 'load balancers (HTTP(S)/TCP)'
                : provider === 'azure'
                ? 'load balancers / App Gateway'
                : 'load balancers',
        armAndSpotTitle:
            provider === 'aws'
                ? 'Adopt Graviton and Spot where suitable'
                : provider === 'gcp'
                ? 'Adopt Arm-based and Preemptible where suitable'
                : provider === 'azure'
                ? 'Adopt Arm-based and Spot where suitable'
                : 'Adopt Arm-based compute where supported',
        armAndSpotDetail: isOnPrem
            ? 'Use Arm-based compute where supported. Improve efficiency via consolidation, right-sizing, and scheduling non-production workloads to off-hours; leverage burst/resource pools as appropriate.'
            : provider === 'aws'
            ? 'Migrate to ARM-based Graviton for 20–40% better price/perf. Use Spot for fault-tolerant, stateless workloads with diversified pools and interruption handling.'
            : provider === 'gcp'
            ? 'Consider Arm-based (T2A) or cost-efficient families and Preemptible VMs for stateless, fault-tolerant workloads with graceful termination.'
            : 'Use Arm-based (e.g., Ampere) where supported and Azure Spot for resilient workloads with eviction handling.',
    }
}
